<div fxLayout fxFlexFill class="parent_container">
  <div fxFlex fxLayout fxLayoutGap="120px" fxLayoutAlign="center center">
    <div fxFlex="400px" fxFlex.lt-md="80">
      <ng-container *ngIf="!loading && !error">
        <h3>Welcome to {{ 'CORE.PRODUCT_NAME' | transloco }}</h3>
        <p>
          Set up a password to activate your account.
          {{ config.MIN_PASSWORD_LENGTH }} characters or more ❤️
        </p>

        <label>Email</label>
        <mat-form-field class="fw">
          <input disabled type="email" matInput [value]="inviteDetails.email" />
        </mat-form-field>

        <label>Password</label>
        <mat-form-field class="fw">
          <input
            type="password"
            placeholder="Create a password"
            matInput
            [(ngModel)]="newPassword"
            (keyup.enter)="setPasswordClicked()" />
        </mat-form-field>

        <label>Password check</label>
        <mat-form-field class="fw">
          <input
            type="password"
            placeholder="Password check"
            matInput
            [(ngModel)]="newPassword2"
            (keyup.enter)="setPasswordClicked()" />
        </mat-form-field>

        <button
          [disabled]="saving"
          type="submit"
          class="invite__button fw"
          mat-flat-button
          (click)="setPasswordClicked()">
          <mat-spinner *ngIf="saving" class="button__spinner" [diameter]="30"></mat-spinner>
          <span>Create account</span>
        </button>
      </ng-container>

      <ng-container *ngIf="loading">
        <mat-spinner [diameter]="32"></mat-spinner>
        <p>Checking a few things...</p>
      </ng-container>

      <ng-container *ngIf="error">
        <p>We're having some trouble validating your invite. Please reach out to support if this keeps happening</p>
      </ng-container>
    </div>
    <div fxHide.lt-md fxFlex>
      <img src="/assets/images/signup/welcome.svg" />
    </div>
  </div>
</div>
